module.exports = __webpack_public_path__ + "static/media/16.185f160d.png";